import React, { FC } from "react";
import { Form, Input, Select } from "antd";
import { Col, Row } from "antd";
import { DatePicker } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";

type WithoutReferralProps = {
  form: any;
  disabled: boolean;
  polyclinicList?: any;
};

const { Option } = Select;

const WithoutReferral: FC<WithoutReferralProps> = ({
  form,
  disabled,
  polyclinicList,
}) => {
  const aadharStatusOptions = [
    {
      label: "Patient does not have an Aadhaar Number",
      value: "Patient does not have an Aadhaar Number",
    },
    {
      label: "Patient has an Aadhaar Number",
      value: "Patient has an Aadhaar Number",
    },
    {
      label: "Patient is NDG / J&K / NE State hence exempted",
      value: "Patient is NDG / J&K / NE State hence exempted",
    },
  ];

  const aadharSelectedValue = Form.useWatch(
    ["patientDetails", "aadharStatus"],
    form,
  );

  const { patients } = useSelector((state: RootState) => state);

  // const dateFormat = "DD-MM-YYYY HH:mm:ss";
  return (
    <div>
      {/* <div
        style={{
          textDecoration: "underline",
          fontSize: "16px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        PATIENT DETAILS
      </div> */}

      <Form
        form={form}
        labelAlign="left"
        layout="vertical"
        labelWrap
        style={{ width: "100%" }}
      >
        <Row gutter={[16, 16]} className="form-row">
          {/* <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="PATIENT NAME" name="fullName">
              <Input disabled={true} placeholder="Enter patient Name" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="AGE" name="age">
              <Input disabled={true} placeholder="Enter age" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="ADDRESS" name="address">
              <Input disabled={true} placeholder="Enter address" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="PHONE NUMBER" name="primaryMobile">
              <Input disabled={true} placeholder="Enter phone Number" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="Referral Type" name="referralType">
              <Input disabled={true} placeholder="Enter referral Type" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="PATIENT TYPE" name="patientType">
              <Input disabled={true} placeholder="Enter patient Type" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="REGION" name="region">
              <Input disabled={true} placeholder="Enter region" />
            </Form.Item>
          </Col> */}

          {/* <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="FINANCIAL YEAR"
              name="financialYear"
            >
              <Input disabled={true} 
              placeholder="Enter financialYear" />
            </Form.Item>
          </Col> */}

          {/* <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="Name Of ESM" name="nameOfESM">
              <Input disabled={true} placeholder="Enter name Of ESM" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="Card TYPE" name="cardType">
              <Input disabled={true} placeholder="Enter card Type" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="Category" name="category">
              <Input disabled={true} placeholder="Enter category" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="WHITE CARD APPLICABLE" name="whitwCardApplicable">
              <Input disabled={true} placeholder="Enter white Card Applicable" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="RANK" name="rank">
              <Input disabled={true} placeholder="Enter rank" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="GENDER" name="gender">
              <Input disabled={true} placeholder="Enter gender" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="RELATION WITH CARD HOLDER"
              name="relationWithCardHolder"
            >
              <Input
                disabled={true}
                placeholder="Enter relation With Card Holder "
              />
            </Form.Item>
          </Col> */}

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="AADHAR CARD STATUS"
              name={["patientDetails", "aadharStatus"]}
              rules={[
                { required: true, message: "Aadhar Card Status is required" },
              ]}
            >
              {/* <Input
                disabled={disabled}
                placeholder="Enter Aadhar Card Status"
              /> */}
              <Select
                disabled={disabled}
                placeholder="Select Aadhar Card Status"
                optionRender={(option) => (
                  <div
                    style={{
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      maxWidth: "100%",
                    }}
                  >
                    {option.label}
                  </div>
                )}
                allowClear
              >
                {aadharStatusOptions?.map((option) => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="AADHAR CARD NUMBER"
              name={["patientDetails", "aadharNumber"]}
              rules={[
                {
                  required:
                    aadharSelectedValue === "Patient has an Aadhaar Number"
                      ? true
                      : false,
                  message: "Aadhar Card Number is required",
                },
                {
                  pattern: /^[2-9]{1}[0-9]{11}$/,
                  message: "Enter a valid 12-digit Aadhaar number",
                },
              ]}
            >
              <Input
                disabled={disabled}
                placeholder="Enter Aadhar Card Number"
                type="text"
                maxLength={12}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  form.setFieldsValue({
                    patientDetails: {
                      ...form.getFieldValue("patientDetails"),
                      aadharNumber: value,
                    },
                  });
                }}
              />
            </Form.Item>
          </Col>

          {/* <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="CITY" name="city">
              <Input disabled={true} placeholder="Enter city " />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="STATE" name="state">
              <Input disabled={true} placeholder="Enter state " />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="PINCODE" name="pincode">
              <Input disabled={true} placeholder="Enter pincode" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="EMAIL" name="email">
              <Input disabled={true} placeholder="Enter email " />
            </Form.Item>
          </Col> */}

          {/* <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="PHONE"
              name="phoneNumber"
            >
              <Input disabled={true} 
              placeholder="Enter phoneNumber " />
            </Form.Item>
          </Col> */}
        </Row>

        <Row gutter={[16, 16]} className="form-row">
          <Col span={4}>
            <Form.Item
              name="beneficiaryId"
              label="BENEFICIARY ID"
              rules={[
                { required: true, message: "Please Input Beneficiary Id" },
              ]}
            >
              <Input disabled={disabled} placeholder="Enter Beneficiary ID" />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              name="patientOpdIpdNumber"
              label="ADMISSION OPD NUMBER"
              rules={[
                {
                  required: true,
                  message: "Please input admission opd number",
                },
              ]}
            >
              <Input
                disabled={disabled}
                placeholder="Enter Admission OPD Number"
              />
            </Form.Item>
          </Col>

          {/* {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
          "OP" ? (
            <></>
          ) : (
            <Col span={5}>
              <Form.Item
                name="approxTreatmentCost"
                label="APPROX TREATMENT COST"
                rules={[
                  //   { required: true, message: "*" },
                  {
                    pattern: /^\d+$/,
                    message: "Only Numeric values are allowed!",
                  },
                ]}
              >
                <Input placeholder="Enter Treatment Cost" disabled={disabled} />
              </Form.Item>
            </Col>
          )} */}

          {/* {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
          "OP" ? (
            <></>
          ) : (
            <Col span={5}>
              <Form.Item
                name="roomType"
                label="ROOM TYPE"
                // rules={[{ required: true, message: "*" }]}
              >
                <Select placeholder="Select Room Type" disabled={disabled}>
                  <Select.Option value="General">GENERAL</Select.Option>
                  <Select.Option value="Private">PRIVATE</Select.Option>
                  <Select.Option value="Semi-Private">
                    SEMI PRIVATE
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col>
          )} */}

          {/* {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
          "OP" ? (
            <></>
          ) : (
            <Col span={4}>
              <Form.Item
                name="roomNumber"
                label="ROOM NUMBER"
                // rules={[{ required: true, message: "*" }]}
              >
                <Input disabled={disabled} placeholder="Enter Room Number" />
              </Form.Item>
            </Col>
          )} */}

          {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
          "OP" ? (
            <Col span={5}>
              <Form.Item
                name="polyClinic"
                label="POLYCLINIC"
                //   rules={[{ required: true, message: "Please select polyclinic" }]}
              >
                <Select placeholder="Select Polyclinic" disabled={disabled}>
                  {polyclinicList?.map((item: any) => (
                    <Select.Option key={item.id} value={item.name}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : (
            <></>
          )}

          <Col span={6}>
            <Form.Item
              name="opdDate"
              label="ADMISSION/OPD DATE/TIME"
              rules={[{ required: true, message: "*" }]}
            >
              <DatePicker
                showTime
                format="DD-MM-YYYY HH:mm:ss"
                style={{ width: "100%" }}
                placeholder="Select Date and Time"
                disabled={disabled}
              />
            </Form.Item>
          </Col>

          {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
          "OP" ? (
            <></>
          ) : (
            <Col span={6}>
              <Form.Item
                name="expectedDischargeDate"
                label="EXPECTED DISCHARGE DATE/TIME"
                rules={[{ required: true, message: "*" }]}
              >
                <DatePicker
                  showTime
                  format="DD-MM-YYYY HH:mm:ss"
                  style={{ width: "100%" }}
                  placeholder="Select Date and Time"
                  disabled={disabled}
                />
              </Form.Item>
            </Col>
          )}
          <Col span={4}>
            <Form.Item
              name="remarks"
              label="REMARKS"
              rules={[{ required: true, message: "Please, enter remarks" }]}
            >
              <Input disabled={disabled} placeholder="Enter Remarks" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default WithoutReferral;
